import { FrontierService } from '@api';
import { InventoryQueryKeys } from '@Inventory/services/queryKeys';
import {
  inventoryIntegrationsTriggerValuesDocument,
  inventoryResourceTypesTriggerValuesDocument,
} from './use-inventory-trigger-values.gql';
import { AqlBuilderField } from '@Inventory/AqlBuilder/helpers/common';
import { useAppQuery } from '@api/query/use-app-query';
import { RISK_LEVEL_VALUE, RISK_LEVEL_VALUE_TO_LABEL } from '@common/utils/risk-score-helpers';

export function useInventoryTriggerValues(ids: string[], field: AqlBuilderField, enabled = true) {
  const fetch = async (): Promise<Map<string, string>> => {
    if (field === AqlBuilderField.integration && ids.length > 0) {
      const res = await FrontierService.request(inventoryIntegrationsTriggerValuesDocument, {
        ids,
      });

      return res.integrations.edges.reduce((acc, edge) => {
        acc.set(edge.node.id, edge.node.name);
        return acc;
      }, new Map());
    }

    if (field === AqlBuilderField.resource_type && ids.length > 0) {
      const res = await FrontierService.request(inventoryResourceTypesTriggerValuesDocument, {
        ids,
      });

      return res.integrationsResourceTypes.reduce((acc, { type, typeDisplayName }) => {
        acc.set(type, typeDisplayName);
        return acc;
      }, new Map());
    }

    if (
      (field === AqlBuilderField.resource_risk_level || field === AqlBuilderField.permission_risk_level) &&
      ids.length > 0
    ) {
      const partialRiskLevelMap = new Map<string, string>();
      for (const id of ids) {
        if (id in RISK_LEVEL_VALUE_TO_LABEL) {
          partialRiskLevelMap.set(id, RISK_LEVEL_VALUE_TO_LABEL[id as RISK_LEVEL_VALUE]);
        }
      }

      return partialRiskLevelMap;
    }

    return new Map();
  };

  return useAppQuery([InventoryQueryKeys.InventoryFilterOptions, JSON.stringify({ ids, type: field })], fetch, {
    keepPreviousData: true,
    enabled,
  });
}
